import { ButtonHTMLAttributes } from "react";
import classNames from "classnames";
import styles from "./UnstyledButton.module.css";

interface UnstyledButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
}

export function UnstyledButton({
  children,
  className,
  ...props
}: UnstyledButtonProps) {
  return (
    <button
      className={classNames(styles.unstyledButton, className)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          props.onClick?.(e as unknown as React.MouseEvent<HTMLButtonElement>);
        }
      }}
      {...props}
    >
      {children}
    </button>
  );
}
